/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnvelopeDocumentModel } from '../models/EnvelopeDocumentModel';
import type { SignableCreateInputModel } from '../models/SignableCreateInputModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SignableService {

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSignableCreate(
requestBody?: SignableCreateInputModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Signable/Create',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param documentId 
   * @returns any Success
   * @throws ApiError
   */
  public static putSignableCancel(
documentId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Signable/Cancel',
      query: {
        'documentId': documentId,
      },
    });
  }

  /**
   * @param documentId 
   * @returns any Success
   * @throws ApiError
   */
  public static putSignableSignableDocument(
documentId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Signable/SignableDocument',
      query: {
        'documentId': documentId,
      },
    });
  }

  /**
   * @param envelopeFingerprint 
   * @param envelopeDocuments 
   * @param envelopeFields 
   * @param envelopeDownload 
   * @param action 
   * @param actionDate 
   * @param envelopeMeta 
   * @returns any Success
   * @throws ApiError
   */
  public static getSignableWebHoockSignable(
envelopeFingerprint?: string,
envelopeDocuments?: Array<EnvelopeDocumentModel>,
envelopeFields?: string,
envelopeDownload?: string,
action?: string,
actionDate?: string,
envelopeMeta?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Signable/WebHoockSignable',
      query: {
        'Envelope_Fingerprint': envelopeFingerprint,
        'Envelope_Documents': envelopeDocuments,
        'Envelope_Fields': envelopeFields,
        'Envelope_Download': envelopeDownload,
        'Action': action,
        'Action_Date': actionDate,
        'Envelope_Meta': envelopeMeta,
      },
    });
  }

  /**
   * @param envelopeFingerprint 
   * @param envelopeDocuments 
   * @param envelopeFields 
   * @param envelopeDownload 
   * @param action 
   * @param actionDate 
   * @param envelopeMeta 
   * @returns any Success
   * @throws ApiError
   */
  public static postSignableWebHoockSignable(
envelopeFingerprint?: string,
envelopeDocuments?: Array<EnvelopeDocumentModel>,
envelopeFields?: string,
envelopeDownload?: string,
action?: string,
actionDate?: string,
envelopeMeta?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Signable/WebHoockSignable',
      query: {
        'Envelope_Fingerprint': envelopeFingerprint,
        'Envelope_Documents': envelopeDocuments,
        'Envelope_Fields': envelopeFields,
        'Envelope_Download': envelopeDownload,
        'Action': action,
        'Action_Date': actionDate,
        'Envelope_Meta': envelopeMeta,
      },
    });
  }

  /**
   * @param envelopeFingerprint 
   * @param action 
   * @param actionDate 
   * @param envelopeMeta 
   * @returns any Success
   * @throws ApiError
   */
  public static getSignableWebHoockSendFailed(
envelopeFingerprint?: string,
action?: string,
actionDate?: string,
envelopeMeta?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Signable/WebHoockSendFailed',
      query: {
        'Envelope_Fingerprint': envelopeFingerprint,
        'Action': action,
        'Action_Date': actionDate,
        'Envelope_Meta': envelopeMeta,
      },
    });
  }

  /**
   * @param envelopeFingerprint 
   * @param action 
   * @param actionDate 
   * @param envelopeMeta 
   * @returns any Success
   * @throws ApiError
   */
  public static postSignableWebHoockSendFailed(
envelopeFingerprint?: string,
action?: string,
actionDate?: string,
envelopeMeta?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Signable/WebHoockSendFailed',
      query: {
        'Envelope_Fingerprint': envelopeFingerprint,
        'Action': action,
        'Action_Date': actionDate,
        'Envelope_Meta': envelopeMeta,
      },
    });
  }

}
